module.exports = __webpack_public_path__ + "img/valleint3.8d4c9f63.png";